import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { ukStamp } from "@/lib/time";
import { Btn, CellMain, CellSub, Empty, Panel, Tag } from "@/components/portal/crm/kit";

/** Connie's chases, waiting for a tap — one text and one email per case, covering everything open for the client. */
export function ClientChasesCard({ testId = "hub-client-chases" }) {
  const [items, setItems] = useState(null);
  const load = () => api.get("/hub/client-chases").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  if (items !== null && items.length === 0) return null;   // nothing due — the desk stays quiet

  return (
    <Panel title="Connie is ready to chase these clients"
           sub="Everything open for the client, in one text and one email with a private link to answer and upload. Nothing goes until you press Send."
           testId={testId}>
      {items === null ? <Empty testId={`${testId}-loading`}>Checking what clients still owe…</Empty> : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {items.map((c) => <Chase key={c.lead_id} c={c} onDone={load} />)}
        </div>
      )}
    </Panel>
  );
}

function Chase({ c, onDone }) {
  const [msg, setMsg] = useState(c.message);
  const [busy, setBusy] = useState(false);
  const how = c.has_phone && c.has_email ? "text and email" : c.has_phone ? "text" : "email";
  const act = async (path, body, ok) => {
    setBusy(true);
    try {
      await api.post(`/hub/client-chases/${c.lead_id}/${path}`, body);
      toast.success(ok);
      onDone();
      window.dispatchEvent(new Event("client-chases:changed"));
    }
    catch (e) { toast.error(e?.response?.data?.detail || "That didn't go"); }
    finally { setBusy(false); }
  };
  return (
    <div className="opt" style={{ display: "block" }} data-testid={`client-chase-${c.lead_id}`}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 10, flexWrap: "wrap" }}>
        <CellMain>{c.name}</CellMain>
        <Tag>{c.kind === "first" ? "First ask" : `Reminder ${c.sends} of 3`}</Tag>
        <CellSub style={{ margin: 0 }}>{[c.reference, c.client, c.last_contact_at && `last contact ${ukStamp(c.last_contact_at)}`].filter(Boolean).join(" · ")}</CellSub>
      </div>
      <CellSub style={{ marginTop: 6 }} data-testid={`client-chase-needs-${c.lead_id}`}>Needs: {c.needs.join(" · ")}</CellSub>
      <textarea className="inp" value={msg} onChange={(e) => setMsg(e.target.value)} rows={3} style={{ marginTop: 10 }}
                data-testid={`client-chase-message-${c.lead_id}`} />
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
        <CellSub style={{ margin: 0, flex: 1 }}>Goes by {how}, with their private link added at the end.</CellSub>
        <Btn onClick={() => act("snooze", {}, "Hidden until tomorrow")} disabled={busy} testId={`client-chase-snooze-${c.lead_id}`}>Not now</Btn>
        <Btn kind="primary" onClick={() => act("send", { message: msg }, `Sent to ${c.client || "the client"} by ${how}`)}
             disabled={busy || msg.trim().length < 10} testId={`client-chase-send-${c.lead_id}`}>
          {busy ? "Sending…" : "Send"}
        </Btn>
      </div>
    </div>
  );
}

export default ClientChasesCard;
